<template>
  <b-card>
    <h1>Blog posts</h1>
    <p
      v-for="blogPost in blogData"
      :key="blogPost.slug"
    >
      <router-link
        :to="`/blog/${blogPost.slug}`"
      >
        {{ blogPost.metaInfo.title }}
      </router-link>
    </p>
  </b-card>
</template>

<script>
import blogData from "./blog-data.js";

export default {
  metaInfo: {
    title: "Blog posts",
  },
  created() {
    this.blogData = blogData;
  },
};
</script>
